// Error codes used throughout the application to handle and identify specific errors
export const ErrorCode = {
    EMAIL_IS_NOT_CORRECT: 801,
    ACCESS_DENIED: 807,
    INVALID_CODE: 811,
    INCOMPLETE_DATA: 817,
    OBJECT_NOT_EXISTS: 831,
    OBJECT_ALREADY_EXISTS: 832,
    USER_EMAIL_ALREADY_EXISTS:1020,
    USER_PHONE_NUMBER_ALREADY_EXISTS:1021,
    USER_DOCUMENT_ID_ALREADY_EXISTS:1022,
    LIST_IS_NULL:880,
    ACCOUNT_LOCKED:2008,
    FOOD_LIMIT_EXCEEDED_ERROR: 2121,
    DEVICES_ALREADY_ASSIGNED: 2129,
    FOODIE_USER_MENU_SELECTION_CHECK_IN_DONE:2143,
    DEVICES_ALREADY_RECORDED_AN_ACCESS: 2144,
    ZONE_WITH_ASSOCIATIONS_IN_ATTENDANCES: 2145,
    ZONE_WITH_ASSOCIATIONS_IN_DEVICES: 2146,
    START_DATE_IN_PAST: 2323,
    INVALID_EXTRA_MEAL_REQUEST_DATA: 3033
};

// Mapping of error code constants to string identifiers for readability and debugging
export const errorCodeName = {
    INVALID_CODE: 'INVALID_CODE',
    INCOMPLETE_DATA: 'INCOMPLETE_DATA',
    OBJECT_NOT_EXISTS: 'OBJECT_NOT_EXISTS',
    OBJECT_ALREADY_EXISTS: 'OBJECT_ALREADY_EXISTS',
    LIST_IS_NULL: 'LIST_IS_NULL'
};

export const warnCodeTranslation = {
    807: 'you_are_unable_to_log_in_please_contact_the_administrator',
    808: 'CONTRACT_EXPIRED',
    2008: 'you_are_unable_to_log_in_please_contact_the_administrator',
    2123: 'no_stock_available_for_menu',
    2129: 'DEVICES_ALREADY_ASSIGNED',
    2136: 'meals_already_selected_for_this_day_time',
    2501: "user_within_cool_down",
    2502: "user_with_warning"
}
// Translations or descriptions for each error code, used to display user-friendly messages
export const errorCodeTranslation = {
    801: 'EMAIL_IS_NOT_CORRECT',
    802: 'PHONE_NUMBER_IS_NOT_CORRECT',
    803: 'DATA_TYPE_MISMATCH',
    804: 'START_DATE_CANNOT_BE_GREATER_THAN_END_DATE',
    805: 'INVALID_USER',
    806: 'INVALID_VEHICLE',
    809: 'OBJECT_WAS_ENDED',
    810: 'INVALID_USER_TYPE',
    811: 'INVALID_CODE',
    812: 'TO_DATE_CANNOT_BE_GREATER_THAN_FROM_DATE',
    813: 'PHONE_NUMBER_MISSING',
    814: 'FILE_SIZE_EXCEEDS',
    815: 'IMAGE_SIZE_EXCEEDS',
    816: 'BAD_CREDENTIALS',
    817: 'INCOMPLETE_DATA',
    818: 'OBJECT_CAN_NOT_BE_UPDATED',
    819: 'NOT_ENOUGH_HOLIDAYS',
    820: 'NO_IMAGE_IN_OBJECT',
    830: 'MISSING_ARGUMENTS_IN_BODY',
    831: 'OBJECT_NOT_EXISTS',
    832: 'OBJECT_ALREADY_EXISTS',
    833: 'OBJECT_WITHOUT_CHANGES',
    834: 'OBJECT_NEEDS_TO_BE_NULL',
    835: 'INVALID_REMOVE',
    836: 'INVALID_UPDATE',
    837: 'NOT_ACCEPTABLE',
    838: 'OBJECT_MUST_NOT_BE_NULL',
    839: "serving_date_cannot_be_in_the_past",
    840: 'FILE_NULL',
    941: 'FILE_NOT_READABLE',
    842: 'UPLOADING_IMAGE',
    843: 'COPYING_IMAGE_IN_LOCAL',
    844: 'SAVING_IMAGE_IN_DB',
    850: 'SMS_ERROR',
    851: 'CALIXTA_ERROR',
    860: 'JWT_NEEDED',
    880: 'LIST_IS_NULL',

    // Device-related errors
    1000: 'DEVICE_IP_ALREADY_EXISTS',
    1001: 'DEVICE_MAC_ALREADY_EXISTS',
    1002: 'DEVICE_SERIAL_NUMBER_ALREADY_EXISTS',
    1003: 'DEVICE_WITH_IP_AND_MAC_NOT_EXISTS',
    1004: 'DEVICE_FIELD_NOT_EXISTS',
    1005: 'DEVICE_WITH_IP_AND_MAC_ALREADY_EXISTS',

    // Employee-related errors
    1010: 'employee_id_already_registered_please_use_another',
    1011: 'EMPLOYEE_FIELD_NOT_EXISTS',
    1012: 'EMPLOYEE_WITH_USER_ID_NOT_EXISTS',

    // User account related
    1020: 'email_already_registered_please_use_another',
    1021: 'phone_number_already_registered_please_use_another',
    1022: "document_ID_already_exists",
    1024: "documentation_user_all_files_required",
    1025: "documentation_user_not_found",
    1026: "documentation_user_file_required",
    // Privilege and access errors
    1030: 'PRIVILEGE_ROOT_OR_NONE_OR_GUARD_ALREADY_EXISTS',
    1031: 'PRIVILEGE_NAME_ALREADY_EXISTS',

    // Home office access-related
    1040: 'HOME_OFFICE_NO_VALID_ACCESS_METHOD',
    1041: 'HOME_OFFICE_ACCESS_METHOD_NULL',

    // Department and workshift
    1080: 'DEPARTMENT_NAME_ALREADY_EXISTS',
    1081: 'WORKSHIFT_NAME_ALREADY_EXISTS',

    // Other domain-specific errors
    1082: 'AIRBNK_WITH_DEVICE_ID_ALREADY_EXISTS',
    1083: 'ONBOARDING_PROCESS_IS_ALREADY_EXISTS',
    1084: 'TAG_NAME_ALREADY_EXISTS',
    1085: 'EMPLOYEE_DOCUMENT_ALREADY_EXISTS',
    1086: 'SUPPLIER_DOCUMENT_ALREADY_EXISTS',
    1087: 'CONTRACTOR_DOCUMENT_ALREADY_EXISTS',
    1088: 'SUPPLIER_VEHICLE',
    1089: 'CONTRACTOR_VEHICLE_DOCUMENT_ALREADY_EXISTS',
    1090: 'department_mismatch_error',
    1091: 'CONTRACT_ALREADY_EXISTS',
    1092: 'USER_ZONE_ALREADY_EXISTS',
    1093: 'DEVICE_EMAIL_ALREADY_EXISTS',
    1094: 'PRIVILEGE_TASK_ALREADY_EXISTS',
    1095: 'EXTRA_DATA_ALREADY_EXISTS',
    1096: 'USER_EMAIL_ALREADY_EXISTS',
    1097: 'FIREARM_ALREADY_EXISTS',
    1098: 'SMART_LOCK_ALREADY_EXISTS',
    1099: 'CONTRACTOR_EMPLOYEE_CONTRACT_ALREADY_EXISTS',

    // Contractor-related
    2000: 'CONTRACTOR_VEHICLE_CONTRACT_ALREADY_EXISTS',
    2001: 'ONBOARDING_ALREADY_EXISTS',
    2002: 'USER_PROCESS_PROCESS_ALREADY_EXISTS',
    2003: 'COMMON_AREA_ALREADY_EXISTS',
    2004: 'CAN_NOT_APPROVE_YOUR_HOLIDAYS_YOURSELF',
    2005: 'OPTION_NOT_EXISTS',
    2006: 'DOCUMENT_ID_CAN_NOT_BE_NULL_OR_EMPTY',
    2007: 'DOCUMENT_ID_NOT_CORRECT',
    2009: 'POSSIBLE_IDENTITY_THEFT_DETECTED',
    2010: "UNLOCKED_ACCOUNT_DENIED", // You don't have access to unlocked this account
    2011: 'ERROR_DURING_DOCUMENT_ID_MATCH_VALIDATION',
    2052: 'HEADERS_CAN_NOT_BE_NULL_OR_EMPTY',
    2053: 'SEARCH_CRITERIA_CAN_NOT_BE_NULL_OR_EMPTY',
    2054: 'USER_TO_FIND_CAN_NOT_BE_NULL_OR_EMPTY',
    2056: 'FROM_DATE_CAN_NOT_BE_NULL',
    2057: 'TO_DATE_CAN_NOT_BE_NULL',
    2090: 'VALIDAS_ERROR_DURING_VALIDATION_PROCESSING',
    2091: 'VERIDAS_SERVICE_IS_NOT_AVAILABLE_ERROR',
    2092: 'VALIDAS_DOCUMENT_TYPE_MISMATCH_DURING_PROCESS',
    2106: 'CANNOT_ADD_MORE_OBJECT_TO_OBJECT',
    2107: 'number_is_already_in_use',
    2111: 'GENERATE_REPORT_FAILED: WEBSOCKET',
    2114: 'ERROR_GENERATING_REPORT',
    2115: 'UNSUPPORTED_CLASS_FOR_PROCESSING',
    2116: 'UNKNOWN_ERROR',
    2117: 'REPORT_LOG_CREATION_FAILED',
    2118: 'EVENTS_CANNOT_BE_DELETED',
    2121: 'has_reached_the_daily_limit',
    2127: 'CANNOT_DELETE_BECAUSE_USE',
    2130: 'CANNOT_BE_DELETED',
    2137 : 'ERROR_WRITING_EXCEL',
    2144: 'device_already_registered_an_access',
    2145: 'CANNOT_DELETE_BECAUSE_USE',
    2146: 'CANNOT_DELETE_BECAUSE_USE',
    2149: 'zone_with_associations_in_attendances',
    // Tenant management
    2201: 'TENANT_UNSUPPORTED_ACS_ID_SCHEMA',
    2202: 'TENANT_ACS_ID_OR_EMAIL_ALREADY_IN_USE',
    2203: 'TENANT_CONTENT_LENGTH_REQUIRED',
    2204: 'TENANT_IMAGE_SIZE_EXCEEDED',
    2205: 'TENANT_VALIDATION_ERROR',
    2228: "DEPARTURE_FAIL",

    2261: 'you_cannot_add_more_sios_to_this_controller',
    2262: 'external_number_port_is_already_in_use',
    2263: 'internal_number_port_is_already_in_use',
    2264: 'scp_id_already_exists',
    2265: 'controller_with_offset_already_exists',
    2266: 'acr_with_zone_already_exists',
    2267: 'acr_with_reader_already_exists',
    2268: 'acr_with_input_already_exists',
    2269: 'acr_with_output_already_exists',
    2270: 'controller_is_not_available',
    2300: 'PASSWORD_CAN_NOT_BE_NULL_OR_EMPTY',

    // approval flow
    2301: 'APPROVAL_FLOW_LEVEL_NOT_DEFINED',
    2302: 'add_at_least_one_level',
    2311: 'add_at_least_one_approver',
    2313: 'approval_flow_exists_for_the_department_and_module',
    2316: 'CANNOT_APPROVE_LEVEL_THAT_IS_NOT_IN_PROGRESS',
    2317: 'LEVEL_IS_ALREADY_COMPLETED',
    2318: 'USER_IS_NOT_AN_APPROVER_FOR_THIS_LEVEL',
    2319: 'USER_HAS_ALREADY_RESPONDED_FOR_THIS_LEVEL',
    2320: 'LEVEL_IS_ALREADY_REJECTED',
    2321: 'start_date_null',
    2322: 'end_date_null',
    2323: 'start_date_in_past',
    2324: 'end_date_in_past',
    2325: 'end_date_before_start_date',
    2326: 'documentation_approval_flow_already_exists',
    // visitor managment
    2410: "please_fill_all_fields",
    2411: "visitor_already_type_name_exist",

    2451: "host_cannot_visitor",
    2452: "only_visitor_allowed",
    2303: "approval_pending_completion",
    2503: "fine_already_paid",
    3001: "cannot_create_outside_range",
    3016: "equipment_category_already_exists",
    3027: "equipment_already_delivered",
    3033: "invalid_extra_meal_request_data"
};
